import { app } from '../../app.module'
app
  // Facebookアカウントテーブルの平均値
  .directive('accountFacebookTableAverage', () => {
    return {
      restrict: 'EA',
      template: require('./account-facebook-table-average.pug')(),
      controller: function ($scope) {
        $scope.$watch(
          () => {
            return $scope.sortAccounts
          },
          () => {
            let followersTotal = 0
            let followersPerPostTotal = 0
            let likesTotal = 0
            let likesPerPostTotal = 0
            let commentsTotal = 0
            let commentsPerPostTotal = 0
            let sharesTotal = 0
            let sharesPerPostTotal = 0
            let engagementsTotal = 0
            let engagementsPerPostTotal = 0
            let engagementRateTotal = 0
            let postCountTotal = 0

            $scope.sortAccounts.forEach(function (account) {
              followersTotal = followersTotal + account.followers
              likesTotal = likesTotal + account.likes
              commentsTotal = commentsTotal + account.comments
              sharesTotal = sharesTotal + account.shares
              engagementsTotal = engagementsTotal + account.engagements
              engagementRateTotal = engagementRateTotal + account.engagementRate
              postCountTotal = postCountTotal + account.posts
              // 投稿数が0より大きい場合、1投稿あたりの平均を会計
              if (account.posts > 0) {
                followersPerPostTotal = followersPerPostTotal + account.followers / account.posts
                likesPerPostTotal = likesPerPostTotal + account.likes / account.posts
                commentsPerPostTotal = commentsPerPostTotal + account.comments / account.posts
                sharesPerPostTotal = sharesPerPostTotal + account.shares / account.posts
                engagementsPerPostTotal =
                  engagementsPerPostTotal + account.engagements / account.posts
              } else {
                followersPerPostTotal = followersPerPostTotal + account.followers
                likesPerPostTotal = likesPerPostTotal + account.likes
                commentsPerPostTotal = commentsPerPostTotal + account.comments
                sharesPerPostTotal = sharesPerPostTotal + account.shares
                engagementsPerPostTotal = engagementsPerPostTotal + account.engagements
              }
            })

            // フォロワー数
            $scope.followersAverage = followersTotal / $scope.sortAccounts.length
            // いいねの平均
            $scope.likesAverage = likesTotal / $scope.sortAccounts.length
            // コメントの平均
            $scope.commentsAverage = commentsTotal / $scope.sortAccounts.length
            // シェアの平均
            $scope.sharesAverage = sharesTotal / $scope.sortAccounts.length
            // 反応数の平均
            $scope.engagementsAverage = engagementsTotal / $scope.sortAccounts.length
            // 反応率の平均
            $scope.engagementRateAverage = engagementRateTotal / $scope.sortAccounts.length
            // 投稿数の平均
            $scope.postsAverage = postCountTotal / $scope.sortAccounts.length

            // 1投稿あたりの平均
            // いいねの平均
            $scope.likesPerPostAverage = likesPerPostTotal / $scope.sortAccounts.length
            // コメントの平均
            $scope.commentsPerPostAverage = commentsPerPostTotal / $scope.sortAccounts.length
            // シェアの平均
            $scope.sharesPerPostAverage = sharesPerPostTotal / $scope.sortAccounts.length
            // 反応数の平均
            $scope.engagementsPerPostAverage = engagementsPerPostTotal / $scope.sortAccounts.length
          }
        )
      },
    }
  })
